import React, { useContext, useEffect, useState, useRef } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { getImages } from '../Components/Common/const'
import { useNavigate } from 'react-router-dom';
import { VehicleContext } from '../Components/Context/VehicleContext';
import SeoMeta from '../Components/Common/SeoMeta';
import { Helmet } from 'react-helmet';
import ReCAPTCHA from 'react-google-recaptcha';
const dropDowns = {};
dropDowns['state'] = ['AK','AL','AR','AS','AZ','CA','CO','CT','DC','DE','FL','GA','GU','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MP','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UM','UT','VA','VI','VT','WA','WI','WV','WY'];


const FinanceDropDown = ({field}) => {
    return (
        <React.Fragment>
            <Field as="select" name={field} className='form-control'>
                <option>Select</option>
                {dropDowns && field in dropDowns && dropDowns[field].map((v,i) => (
                    <option key={i} value={v}>{v}</option>
                ))}
            </Field>
            <ErrorMessage name={field} component='div' className='text-danger' />
        </React.Fragment>
    )
}
const Finance = () => {

    const { submitContactForm, vehicleListSearch } = useContext(VehicleContext);
    const recaptchaRef = React.useRef();

    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        // fullName: Yup.string()
        //     .required('Full Name is required'),
        // email: Yup.string()
        //     .email('Invalid email address')
        //     .required('Email is required'),
        // phone: Yup.string()
        //     .required('Phone number is required'),
        // comments: Yup.string()
        //     .max(500, 'Comments cannot exceed 500 characters')
    });

    const [vehicleYears, setVehicleYears] = useState([]);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [vehicleModels, setVehicleModels] = useState([]);
    const [vehicleTrims, setVehicleTrims] = useState([]);

    const [vehicleYearData, setVehicleYearData] = useState([]);

    const formikRef = useRef();

    useEffect(() => {

        if (!vehicleYears || vehicleYears.length === 0) {

            getVehicleYears();
        }
    }, []);

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({ 'subject': 'year' });
        console.log(data);
        setVehicleYears(data);
    }

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({ 'subject': 'yeardata', 'year': year });
        console.log(data);

        setVehicleYearData(data);

        let makes = [];

        if ('makes' in data) {
            data['makes'].map((make, i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year, make) => {
        console.log(year, make);

        if ('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                console.log(make);
                if ('models' in make) {
                    make['models'].map((model, j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }

    const getVehicleTrims = async (year, make, model) => {
        console.log(year, make, model);

        if ('makes' in vehicleYearData) {

            let trims = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make, i) => {
                console.log(make);
                if ('models' in make) {
                    make['models'].filter((item) => item.name == model).map((model, j) => {
                        if ('trims' in model) {
                            model['trims'].map((trim, k) => {
                                trims.push(trim.name);
                            })
                        }
                    })
                }
            });

            setVehicleTrims(trims);
        }
    }

    return (
        <>
            <Helmet>
                <title>Mercedes-Benz Financing Options | Easy Auto Loans</title>
                <meta name="description" content="Secure low-interest auto loans for your next Mercedes-Benz. Quick approvals and flexible terms available." />
                <meta name="keywords" content="" />
                <meta property="og:title" content="Mercedes-Benz Financing Options | Easy Auto Loans" />
                <meta property="og:description" content="Secure low-interest auto loans for your next Mercedes-Benz. Quick approvals and flexible terms available." />
            </Helmet>
            <section className='common-wrap d-flex align-items-center' style={{ backgroundImage: `url(${getImages('finance-hero-bg.webp')})` }}>
                <div className='w-100'>
                    <div className='container'>
                        <h1 className='xl-title text-uppercase text-center wow reveal fadeInUp'>Finance</h1>
                        <h2 className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp'>Flexible Financing Options</h2>
                    </div>
                </div>
            </section>
            <section className='drive-home-wrap d-lg-flex align-items-center'>
                <div className='w-50 order-2'>
                    <img className="w-100" src={getImages('drive-image.webp')} />
                </div>
                <div className='w-50'>
                    <div className='mxw-580 mx-auto px-xl-0 px-4'>
                        <h3 className='lg-title text-uppercase mb-3'>Drive Your Dream Car Home</h3>
                        <div className="common-text">
                            <p>No matter what your financing needs are, our finance manager is ready to help you with our low, competitive rates. We work with several local and national financial institutions to provide our customers with the best loan program to meet your individual needs.  We’re here six days a week, and it’s as easy as filling out the ez credit application. It will be our pleasure to assist you with your financing needs.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className='finance-wrap'>
                <div className='container'>
                    <Formik
                        initialValues={{
                            firstName: '',
                            lastName: '',
                            mi: '',
                            dob: '',
                            social_security_number: '',
                            marital_status: '',
                            address: '',
                            city: '',
                            state: '',
                            zip: '',
                            noy_at_address: '',
                            home_phone: '',
                            email: '',
                            property_rent_own: '',
                            monthly_payment: '',

                            spouse_first_name: '',
                            spouse_last_name: '',
                            spouse_mi: '',
                            spouse_dob: '',
                            spouse_social_security_number: '',

                            employment_employer: '',
                            employment_position: '',
                            employment_work_phone: '',
                            employment_gas: '',
                            employment_yae: '',
                            employment_previous_employer: '',
                            employment_yape: '',

                            spouse_employment_employer: '',
                            spouse_employment_position: '',
                            spouse_employment_work_phone: '',
                            spouse_employment_gas: '',
                            spouse_employment_yae: '',
                            spouse_employment_previous_employer: '',
                            spouse_employment_yape: '',
                        }}
                        validationSchema={validationSchema}
                        innerRef={formikRef}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            console.log('reCAPTCHA token:', token);
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);

                            const data = await submitContactForm(values);

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue }) => (
                            <Form className='custom-form finance-form'>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6LfuE4MrAAAAAJdFHXLQK_ktBMzfl8C9I5fpmiJU" // Replace with your actual site key
                                    size="invisible"
                                />
                                <div className='form-black-box'>
                                    <div className='lg-title fw-500 mb-3'>Vehicle Information</div>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <label className='cs-label mb-2' htmlFor='year'>Year</label>
                                            <Field
                                                as="select"
                                                name="year"
                                                className="form-control"
                                                onChange={(e) => { setFieldValue('year', e.target.value); getVehicleYearData(e.target.value); }}
                                            >
                                                <option value=''>
                                                    Select
                                                </option>
                                                {vehicleYears.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name='year' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4'>
                                            <label className='cs-label mb-2' htmlFor='make'>Make</label>
                                            <Field
                                                as="select"
                                                name="make"
                                                className="form-control"
                                                onChange={(e) => { setFieldValue('make', e.target.value); getVehicleModels(values.year, e.target.value); }}
                                            >
                                                <option value=''>
                                                    Select
                                                </option>
                                                {vehicleMakes.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name='make' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4'>
                                            <label className='cs-label mb-2' htmlFor='model'>Model</label>
                                            <Field
                                                as="select"
                                                name="model"
                                                className="form-control"
                                                onChange={(e) => { setFieldValue('model', e.target.value); getVehicleTrims(values.year, values.make, e.target.value); }}
                                            >
                                                <option value=''>
                                                    Select
                                                </option>
                                                {vehicleModels.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name='model' component='div' className='text-danger' />
                                        </div>
                                    </div>
                                </div>
                                <div className='form-black-box mt-4'>
                                    <div className='md-title font-1-2em fw-500 mb-3 text-white'>Personal Information</div>
                                    <hr className='custom-hr' />
                                    <div className='row'>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='firstName'>First Name</label>
                                            <Field type="text" name='firstName' className='form-control' />
                                            <ErrorMessage name='firstName' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='lastName'>Last Name</label>
                                            <Field type="text" name='lastName' className='form-control' />
                                            <ErrorMessage name='lastName' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='mi'>MI</label>
                                            <Field type="text" name='mi' className='form-control' />
                                            <ErrorMessage name='mi' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='dob'>Date of Birth</label>
                                            <Field type="text" name='dob' className='form-control' />
                                            <ErrorMessage name='dob' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='social_security_number'>Social Security Number</label>
                                            <Field type="text" name='social_security_number' className='form-control' />
                                            <ErrorMessage name='social_security_number' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='marital_status'>Marital Status</label>
                                            <Field as="select" name='marital_status' className='form-control'>
                                                <option value="">Select</option>
                                                <option value="married">Married</option>
                                                <option value="single">Single</option>
                                            </Field>
                                            <ErrorMessage name='marital_status' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='address'>Address</label>
                                            <Field type="text" name='address' className='form-control' />
                                            <ErrorMessage name='address' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='city'>City</label>
                                            <Field type="text" name='city' className='form-control' />
                                            <ErrorMessage name='city' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='state'>State</label>
                                            <FinanceDropDown field={'state'} />
                                            <ErrorMessage name='state' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='zip'>Zip</label>
                                            <Field type="text" name='zip' className='form-control' />
                                            <ErrorMessage name='zip' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='noy_at_address'>Number of Years at Address</label>
                                            <Field as="select" name='noy_at_address' className='form-control'>
                                                <option value="">Select</option>
                                                {[...Array(20)].map((_, i) => (
                                                    <option key={i + 1} value={i + 1}>
                                                        {i + 1}
                                                    </option>
                                                ))}
                                            </Field>
                                            <ErrorMessage name='noy_at_address' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='home_phone'>Home Phone</label>
                                            <Field type="text" name='home_phone' className='form-control' />
                                            <ErrorMessage name='home_phone' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='email'>Email</label>
                                            <Field type="text" name='email' className='form-control' />
                                            <ErrorMessage name='email' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2'>Do You Own or Rent Your Property?</label>
                                            <div className="d-flex gap-3">
                                                <div className="custom-radio">
                                                    <Field
                                                        type="radio"
                                                        name="property_rent_own"
                                                        value="Own"
                                                        id="propert_own"
                                                    />
                                                    <label htmlFor='propert_own'>Own</label>
                                                </div>

                                                <div className="custom-radio">
                                                    <Field
                                                        type="radio"
                                                        name="property_rent_own"
                                                        value="Rent"
                                                        id="propert_rent"
                                                    />
                                                    <label htmlFor='propert_rent'>Rent</label>
                                                </div>
                                            </div>
                                            <ErrorMessage name='email' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='monthly_payment'>Monthly Payment (approx.):</label>
                                            <Field type="text" name='monthly_payment' className='form-control' />
                                            <ErrorMessage name='monthly_payment' component='div' className='text-danger' />
                                        </div>
                                    </div>

                                    {/* Spouse Information */}
                                    <div className='md-title font-1-2em fw-500 mb-3 text-white mt-5'>Spouse Information</div>
                                    <hr className='custom-hr' />
                                    <div className='row'>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_first_name'>First Name</label>
                                            <Field type="text" name='spouse_first_name' className='form-control' />
                                            <ErrorMessage name='spouse_first_name' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_last_name'>Last Name</label>
                                            <Field type="text" name='spouse_last_name' className='form-control' />
                                            <ErrorMessage name='spouse_last_name' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_mi'>MI</label>
                                            <Field type="text" name='spouse_mi' className='form-control' />
                                            <ErrorMessage name='spouse_mi' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_dob'>Date of Birth</label>
                                            <Field type="text" name='spouse_dob' className='form-control' />
                                            <ErrorMessage name='spouse_dob' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_social_security_number'>Social Security Number</label>
                                            <Field type="text" name='spouse_social_security_number' className='form-control' />
                                            <ErrorMessage name='spouse_social_security_number' component='div' className='text-danger' />
                                        </div>
                                    </div>

                                    {/* Employment Information */}
                                    <div className='md-title font-1-2em fw-500 mb-3 text-white mt-5'>Employment Information</div>
                                    <hr className='custom-hr' />
                                    <div className='row'>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_employer'>Employer</label>
                                            <Field type="text" name='employment_employer' className='form-control' />
                                            <ErrorMessage name='employment_employer' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_position'>Position</label>
                                            <Field type="text" name='employment_position' className='form-control' />
                                            <ErrorMessage name='employment_position' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_work_phone'>Work Phone</label>
                                            <Field type="text" name='employment_work_phone' className='form-control' />
                                            <ErrorMessage name='employment_work_phone' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_gas'>Gross Annual Salary</label>
                                            <Field type="text" name='employment_gas' className='form-control'/>
                                            <ErrorMessage name='employment_gas' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_yae'>Years at Employer</label>
                                            <Field type="text" name='employment_yae' className='form-control'/>
                                            <ErrorMessage name='employment_yae' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_previous_employer'>Previous Employer</label>
                                            <Field type="text" name='employment_previous_employer' className='form-control' />
                                            <ErrorMessage name='employment_previous_employer' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='employment_yape'>Years at Previous Employer</label>
                                            <Field type="text" name='employment_yape' className='form-control'/>
                                            <ErrorMessage name='employment_yape' component='div' className='text-danger' />
                                        </div>
                                    </div>

                                    {/* Spouse Employment Information */}
                                    <div className='md-title font-1-2em fw-500 mb-3 text-white mt-5'>Spouse Employment Information</div>
                                    <hr className='custom-hr' />
                                    <div className='row'>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_employer'>Employer</label>
                                            <Field type="text" name='spouse_employment_employer' className='form-control' />
                                            <ErrorMessage name='spouse_employment_employer' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_position'>Position</label>
                                            <Field type="text" name='spouse_employment_position' className='form-control' />
                                            <ErrorMessage name='spouse_employment_position' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_work_phone'>Work Phone</label>
                                            <Field type="text" name='spouse_employment_work_phone' className='form-control' />
                                            <ErrorMessage name='spouse_employment_work_phone' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_gas'>Gross Annual Salary</label>
                                            <Field type="text" name='spouse_employment_gas' className='form-control'/>
                                            <ErrorMessage name='spouse_employment_gas' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-2 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_yae'>Years at Employer</label>
                                            <Field type="text" name='spouse_employment_yae' className='form-control'/>
                                            <ErrorMessage name='spouse_employment_yae' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_previous_employer'>Previous Employer</label>
                                            <Field type="text" name='spouse_employment_previous_employer' className='form-control' />
                                            <ErrorMessage name='spouse_employment_previous_employer' component='div' className='text-danger' />
                                        </div>
                                        <div className='col-md-4 form-group'>
                                            <label className='cs-label mb-2' htmlFor='spouse_employment_yape'>Years at Previous Employer</label>
                                            <Field type="text" name='spouse_employment_yape' className='form-control'/>
                                            <ErrorMessage name='spouse_employment_yape' component='div' className='text-danger' />
                                        </div>
                                    </div>
                                    <div className='row mt-150'>
                                        <div className='col-md-6'>
                                            <p className='cs-text fw-300'>By submitting this secure form, your electronically sign the above form and give Mercedeshowroom the authority to view credit bureau reports.
                                            </p>
                                        </div>
                                        <div className='col-md-6'>
                                            <button type='submit' className='transparent-btn w-100 lg-btn text-uppercase'>Apply</button>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </section>
        </>
    )
}

export default Finance